import {
  apiRequest,
  detailPeriodTunsus,
} from "../../../../../services/adapters/kepegawaian/revisiTunjanganKhususService";

class IndexRepository {
  fetchDetail = async (query, cancelToken) => {
    return await apiRequest(
      "get",
      detailPeriodTunsus,
      {
        cancelToken: cancelToken,
        params: query,
      },
      true
    );
  };
}

export default IndexRepository;
